<script setup lang="ts"></script>

<template>
  <icon name="material-symbols:comment" />
</template>

<style scoped></style>
